import { BOOK_CALL_HREF } from '@/lib/constants';

/**
 * Code-owned chrome for the shared FAQ section (homepage, /about,
 * /shopify-experts, /shopify-services). The heading, the "Still have
 * questions?" copy and every question and answer stay in Sanity (or in
 * `shopify-hub-extras.ts` for the two hubs); this file only holds the button
 * labels around them.
 *
 * Facts restated, not new:
 *  - "free 30-min call": the Calendly intro event is 30 minutes and free
 *    (book.ts BOOK_DETAILS; homepage.ts BOOK_CALL_SECONDARY_LABEL).
 *  - The reply promise is rendered by `FounderReplyBadge` from
 *    FOUNDER_REPLY_BADGE, so it cannot drift from the forms.
 *
 * The two links are the section's existing destinations: the booking page
 * and the contact form (`/#contact`, resolved per page by
 * `localizeAnchorHref`: the in-page form where there is one, else /contacts).
 */
export const FAQ_SECTION_COPY = {
  bookCall: { label: 'Book a free 30-min call', href: BOOK_CALL_HREF },
  contact: { label: 'Send us a message', href: '/#contact' },
  socialLabel: 'Follow EVDEV',
} as const;

/**
 * Sanity numbers the homepage questions ("03/What factors …"). The number is
 * noise in a scannable list, so the section hides it visually while keeping
 * the authored string intact in the HTML. Same pattern the homepage FAQPage
 * JSON-LD uses to strip it (src/app/(marketing)/page.tsx).
 */
const NUMBER_PREFIX = /^(\s*\d+\s*\/\s*)/;

export function splitQuestionPrefix(question: string): {
  prefix: string;
  text: string;
} {
  const match = NUMBER_PREFIX.exec(question);
  if (!match) return { prefix: '', text: question };
  return { prefix: match[1]!, text: question.slice(match[1]!.length) };
}
